module.exports = __webpack_public_path__ + "static/img/2_13.ebc47cd5.jpg";